<app-header></app-header>
<div class="container-fluid" #sourceContainer>
  <div id="source-picker" class="row">
    <div id="select-bank" class="col-md-6 col-lg-6 col-xl-6 p-top-20">
      <div class="col-md-11 col-lg-11 col-xl-11">
        <h4 class="m-right-9 fa">Add question</h4>
        <h2 class="m-right-9 fa">Choose a source to pick from</h2>
        <source-picker></source-picker>
      </div>
    </div>
    <div class="col-md-6 col-lg-6 col-xl-6">
    </div>
  </div>
</div>
<app-footer></app-footer>